module.exports = __webpack_public_path__ + "public/img/logo-vertical.7fc7b3d8.svg";